﻿import React from 'react';
import HazardStatementsComponent from './HazardStatementsComponent';

export default function HazardStatementsMaintenanceForm() {

    return (
        <div>
            <HazardStatementsComponent modal={true} />
        </div>
    );

}